<div class="max-w-7xl mx-auto pl-4 pr-4 md:pl-6 md:pr-6 space-y-6">
  <!-- Estado de carga -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
  </div>

  <ng-container *ngIf="!loading">

    <!-- Selector de Monedero (Siempre visible si hay opciones) -->
    <div class="flex justify-between items-center mb-4" *ngIf="productOptions.length > 0 && activeProductId == null">
      <div class="text-sm text-gray-600">
        <span class="font-semibold">Vista:</span>
        <span class="ml-2">{{ getSelectedProductLabel() }}</span>
      </div>
      <p-dropdown [options]="productOptions" [(ngModel)]="selectedProductId" (onChange)="onProductChange()"
        optionLabel="label" optionValue="value" [style]="{'min-width': '250px'}" placeholder="Seleccionar Monedero">
      </p-dropdown>
    </div>

    <!-- Mensaje si no hay productos contratados -->
    <div *ngIf="productOptions.length === 0" class="bg-white rounded-2xl shadow-lg p-12 text-center">
      <i class="pi pi-wallet text-6xl text-gray-300 mb-4"></i>
      <p class="text-gray-500 text-lg">Este usuario no tiene productos contratados.</p>
      <p class="text-gray-400 text-sm mt-2">Al contratar un producto se creará automáticamente su monedero.</p>
    </div>

    <!-- Mensaje si no hay wallet y no se ha seleccionado nada -->
    <div *ngIf="!wallet && !loading && productOptions.length > 0 && !selectedProductId" class="bg-white rounded-2xl shadow-lg p-12 text-center">
      <i class="pi pi-wallet text-6xl text-gray-300 mb-4"></i>
      <p class="text-gray-500 text-lg">Selecciona un producto para ver su monedero.</p>
    </div>

    <div *ngIf="wallet" class="space-y-4">
      <!-- Tarjetas de Saldos -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <!-- Tarjeta de Saldo Principal (€) -->
        <div class="bg-gradient-to-br from-red-600 via-red-700 to-red-800 rounded-xl shadow-lg p-4 md:p-5 text-white">
          <div class="flex justify-between items-start mb-4">
            <div class="flex-1">
              <p class="text-xs font-semibold uppercase tracking-wider opacity-90 mb-1">
                Saldo Disponible (€)
              </p>
              <h1 class="text-2xl md:text-3xl font-bold">{{ wallet.balance | number:'1.2-2' }}€</h1>
            </div>
          </div>

          <div class="grid grid-cols-2 lg:grid-cols-3 gap-2">
            <button type="button" (click)="openActionDialog('recharge')"
              class="bg-white hover:bg-gray-50 text-black font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm">
              <i class="pi pi-plus-circle text-base"></i>
              <span>Recargar</span>
            </button>
            <button type="button" (click)="openActionDialog('charge')"
              class="bg-white hover:bg-gray-50 text-black font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm">
              <i class="pi pi-minus-circle text-base"></i>
              <span>Cobrar</span>
            </button>
            <button type="button" (click)="openActionDialog('refund')"
              class="bg-white hover:bg-gray-50 text-black font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm">
              <i class="pi pi-replay text-base"></i>
              <span>Reembolsar</span>
            </button>
          </div>
        </div>

        <!-- Tarjeta de Prácticas -->
        <div
          class="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 rounded-xl shadow-lg p-4 md:p-5 text-white">
          <div class="flex justify-between items-start mb-4">
            <div class="flex-1">
              <p class="text-xs font-semibold uppercase tracking-wider opacity-90 mb-1">
                Saldo de Prácticas
              </p>
              <div class="grid grid-cols-2 gap-3 mt-2">
                <div>
                  <p class="text-xs opacity-75">Abierto</p>
                  <h2 class="text-xl md:text-2xl font-bold">{{ wallet.practice_balance_normal || 0 }}</h2>
                </div>
                <div>
                  <p class="text-xs opacity-75">Maniobras</p>
                  <h2 class="text-xl md:text-2xl font-bold">{{ wallet.practice_balance_maniobras || 0 }}</h2>
                </div>
              </div>
            </div>
            <i class="pi pi-car text-4xl opacity-25"></i>
          </div>

          <div class="grid grid-cols-1 gap-2">
            <button type="button" (click)="openActionDialog('buyPractices')"
              class="bg-white hover:bg-gray-50 text-black font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm w-full">
              <i class="pi pi-shopping-cart text-base"></i>
              <span>Comprar Prácticas</span>
            </button>
          </div>
        </div>

      </div>

      <!-- Grid de Estadísticas -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pb-6" *ngIf="stats">
        <!-- Total Recargas -->
        <div
          class="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 p-4 border-l-4 border-green-500">
          <p class="text-xs text-gray-500 font-medium mb-1">Total Recargas</p>
          <p class="text-xl font-bold text-gray-800">{{ stats.total_recharges | number:'1.2-2' }}€</p>
        </div>

        <!-- Total Cargos -->
        <div
          class="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 p-4 border-l-4 border-red-500">
          <p class="text-xs text-gray-500 font-medium mb-1">Total Cargos</p>
          <p class="text-xl font-bold text-gray-800">{{ stats.total_charges | number:'1.2-2' }}€</p>
        </div>

        <!-- Total Reembolsos -->
        <div
          class="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 p-4 border-l-4 border-blue-500">
          <p class="text-xs text-gray-500 font-medium mb-1">Total Reembolsos</p>
          <p class="text-xl font-bold text-gray-800">{{ stats.total_refunds | number:'1.2-2' }}€</p>
        </div>

        <!-- Total Transacciones -->
        <div
          class="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200 p-4 border-l-4 border-purple-500">
          <p class="text-xs text-gray-500 font-medium mb-1">Transacciones</p>
          <p class="text-xl font-bold text-gray-800">{{ stats.total_transactions }}</p>
        </div>
      </div>

      <!-- Historial de Transacciones -->
      <app-generic-table *ngIf="transactionsTable && hasTransactions"
        [genericTable]="transactionsTable"></app-generic-table>
    </div>
  </ng-container>
</div>